import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Home } from 'lucide-react';

export default function NotFound() {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen flex flex-col items-center justify-center px-4 bg-background">
            <div className="text-center space-y-4">
                <h1 className="text-6xl font-bold text-muted-foreground/30">404</h1>
                <h2 className="text-xl font-semibold text-foreground">Page not found</h2>
                <p className="text-sm text-muted-foreground max-w-sm">
                    The page you're looking for doesn't exist or has been moved.
                </p>
                <Button
                    onClick={() => navigate('/summary')}
                    className="mt-4"
                >
                    <Home className="h-4 w-4 mr-2" />
                    Go to Contract
                </Button>
            </div>
        </div>
    );
}
